var _circle, _g, _circle2, _circle3, _circle4, _circle5, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaymentsHistoryEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 153 118"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 52,
    r: 52,
    fill: "#E4E7EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#payments-history-empty_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 72,
    x: 18.5,
    y: 12,
    fill: "url(#payments-history-empty_svg__b)",
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    x: 28.5,
    y: 26,
    fill: "#D0D5DD",
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.167,
    cy: 32.333,
    r: 8.333,
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.167,
    cy: 32.333,
    r: 8.333,
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D5DD",
    d: "M28.5 73.667c0-.92.746-1.667 1.667-1.667h16.666a1.667 1.667 0 110 3.333H30.167c-.92 0-1.667-.746-1.667-1.666zm25 0c0-.92.746-1.667 1.667-1.667h16.666a1.667 1.667 0 110 3.333H55.167c-.92 0-1.667-.746-1.667-1.666zm25 0c0-.92.746-1.667 1.667-1.667h16.666a1.667 1.667 0 110 3.333H80.167c-.92 0-1.667-.746-1.667-1.666zm25 0c0-.92.746-1.667 1.667-1.667h16.666a1.667 1.667 0 110 3.333h-16.666a1.667 1.667 0 01-1.667-1.666z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 5,
    r: 5,
    fill: "#F2F4F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 109,
    r: 7,
    fill: "#F2F4F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 35,
    r: 7,
    fill: "#F2F4F7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 8,
    r: 4,
    fill: "#F2F4F7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#payments-history-empty_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 52.5,
    y: 70,
    fill: "#344054",
    fillOpacity: 0.4,
    rx: 24
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M76.5 90v4m0 4h.01m9.99-4c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "payments-history-empty_svg__a",
    width: 148.333,
    height: 105.333,
    x: 1.833,
    y: 12,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 3.333,
    result: "effect1_dropShadow_4350_135747"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4350_135747"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 3.333,
    result: "effect2_dropShadow_4350_135747"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16.667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4350_135747",
    result: "effect2_dropShadow_4350_135747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4350_135747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "payments-history-empty_svg__c",
    width: 64,
    height: 64,
    x: 44.5,
    y: 62,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4350_135747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_4350_135747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "payments-history-empty_svg__b",
    x1: 22.505,
    x2: 20.413,
    y1: 83.148,
    y2: 17.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FAFB"
  })))));
}

export default SvgPaymentsHistoryEmpty;